import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';
import Layout from '../../../components/layout/Layout';
import BusinessForm from '../components/BusinessForm';
import { Building } from 'lucide-react';

const BusinessPage: React.FC = () => {
  const { needsOnboarding } = useAuth();
  const navigate = useNavigate();

  const handleSuccess = () => {
    if (needsOnboarding) {
      navigate('/dashboard', { replace: true });
    }
  };

  return (
    <Layout>
      <div className="space-y-8">
        {/* Header Section */}
        <div className="animate-fade-in-up" style={{ animationDelay: '0.1s' }}>
          <h1 className="text-2xl font-bold text-content flex items-center">
            <Building className="h-6 w-6 mr-2 text-accent" />
            Mi Negocio
          </h1>
          <p className="mt-1 text-sm text-content-2">
            Gestiona la información de tu negocio
          </p>
        </div>

        {/* Form Section */}
        <div className="animate-fade-in-up" style={{ animationDelay: '0.15s' }}>
          <BusinessForm onSuccess={handleSuccess} />
        </div>
      </div>
    </Layout>
  );
};

export default BusinessPage;